import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Activity } from "lucide-react";

// Friendly display labels — internal action enums keep 'approval_point_*' for backward compat
// while users see 'action_point_*' wording (per FlowQA terminology: AP = Action Point).
const displayAction = (raw) => (raw || "").replace(/approval_point/g, "action_point");

export default function AuditTrail() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs").then(r => setLogs(r.data)); }, []);
  return (
    <div className="p-4 md:p-8" data-testid="audit-trail-page">
      <div className="mb-6">
        <div className="overline mb-1">System</div>
        <h1 className="font-heading text-3xl font-black tracking-tighter sm:text-4xl">Audit Trail</h1>
        <p className="text-sm text-slate-600">Immutable timeline of every action across FlowQA.</p>
      </div>
      <div className="space-y-2">
        {logs.map(a => (
          <Card key={a.id} className="border-slate-200 p-3" data-testid={`audit-entry-${a.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
              <div className="flex items-center gap-2">
                <Activity className="size-3.5 text-slate-400"/>
                <span className="font-mono text-xs text-slate-500">{new Date(a.timestamp).toLocaleString()}</span>
                <span className="font-semibold text-slate-900">{a.user_name}</span>
                <span className="overline">{a.role}</span>
              </div>
              <span className="font-mono text-xs font-bold text-teal-700" data-testid={`audit-action-${a.id}`}>{displayAction(a.action)}</span>
            </div>
            {(a.previous_status || a.new_status) && (
              <div className="mt-1 text-xs text-slate-600">{a.previous_status && <>From <b>{a.previous_status}</b> →</>} <b>{a.new_status}</b></div>
            )}
            {a.comment && <div className="mt-1 text-xs text-slate-700">{a.comment.replace(/approval point/gi, "action point")}</div>}
          </Card>
        ))}
        {logs.length === 0 && <div className="text-slate-500">No audit entries.</div>}
      </div>
    </div>
  );
}
